import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import { useState } from "react";
import { apiPath } from "../../../utility/Constant";
import { useEffect } from "react";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import { updateData } from "../../../hooks/update";

function WorkAddpage() {
  const { CSRApi } = apiPath;

  const data = [
    {
      elementType: "file",
      label: "Work Featured Image",
      type: "text",
      name: "ourWorkSingleImg",
    },
    {
      elementType: "textField",
      label: "Work Title",
      type: "text",
      name: "ourWorkTitle",
    },
    {
      elementType: "textField",
      label: "Work Subtitle",
      type: "text",
      name: "ourWorkSubTitle",
    },
    {
      elementType: "textField",
      label: "Work Details",
      type: "text",
      name: "ourWorkDetails",
    },
  ];

  const imagesData = [];
  //   []?.map((item, index) => {
  //     imagesData.push({
  //       label: `Gallery Image ${index}`,
  //       type: "file",
  //       name: "",
  //       defaultValue: "",
  //       required: false,
  //     });
  //   });

  const nestedData = [
    {
      elementType: "file",
      label: "Gallery Image",
      name: "ourWorkImages",
      multipleData: imagesData,
      multiple: true,
      fullCol: true,
      required: false,
    },
  ];

  const useData = data.concat(nestedData);

  const update = (data) => {
    const fData = data.ourWorkImages.map((item) => {
      let obj = {};
      obj.url = item;
      return obj;
    });
    data.ourWorkImages = fData;
    data.slug = "work";
    console.log(data);
    updateData(`${CSRApi}`, data, null, null, null, true);
  };

  return (
    <div>
      <GlobalForm data={useData} nestedData={nestedData} update={update} />
    </div>
  );
}

export default WorkAddpage;
